import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-shape/src/order/reverse.js
// module id = 210
// module chunks = 0